import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McoClaimLineList = ({ mcoClaim }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!mcoClaim) return;

      rowsReq.partition = mcoClaim.partition;
      rowsReq.expr = ExprUtils.and(
        rowsReq.expr,
        ExprUtils.whereParams(
          'rbtPeriodId',
          mcoClaim.rbtPeriodId,
          'mcoClaimId',
          mcoClaim.id,
        ),
      );
    },
    [mcoClaim?.partition, mcoClaim?.id],
  );

  const augFieldDefs = (fieldToFieldDef) => {
    // 1. Dimensions
    fieldToFieldDef.rbtPeriodId.precedence = 1;
    fieldToFieldDef.rbtPeriodId.hasName = false;

    fieldToFieldDef.prodId.precedence = 2;
    fieldToFieldDef.prodId.hasName = false;

    fieldToFieldDef.planCustId.precedence = 2;
    fieldToFieldDef.planCustId.hasName = true;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;

    // 3. Units
    fieldToFieldDef.invUnits.precedence = 2000;
    fieldToFieldDef.openDispUnits.precedence = 2001;
    fieldToFieldDef.calcDispUnits.precedence = 2002;
    fieldToFieldDef.dueUnits.precedence = 2003;
    fieldToFieldDef.paidUnits.precedence = 2004;

    // 4. Amounts
    fieldToFieldDef.invAmt.precedence = 3001;
    fieldToFieldDef.dispAmt.precedence = 4003;
    fieldToFieldDef.dueAmt.precedence = 3004;
    fieldToFieldDef.paidAmt.precedence = 3005;
  };

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Utlization Lines come from system only
  };

  return (
    <EntityList
      entity="MCO_CLAIM_LINE"
      augRowsReq={augRowsReq}
      augTabButtons={augTabButtons}
      augFieldDefs={augFieldDefs}
    />
  );
};
